module.exports = __webpack_public_path__ + "img/alpha.3549b02a.png";